import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { filter, map, takeWhile, tap, withLatestFrom } from 'rxjs/operators';
import { Contract } from '../../account/account-allocations';
import * as fromDataServices from '../../data-services';
import * as fromLookups from '../../lookups';
import {
    CalcType,
    IDirectReport,
    IServiceItem,
    ITask,
    IUserGroup,
    LoadServiceItems
} from '../../lookups';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ContractCumulativePresenterComponent } from '../presenter/contract-cumulative-presenter.component';
import { SessionDates } from '../SessionDates';
import * as fromActions from '../store/contract-cumulative.actions';
import { ContractCumulative } from '../store/contract-cumulative.model';
import * as fromReducer from '../store/contract-cumulative.reducer';
import * as fromReports from '../../reporting/store';
import { ReportParams } from '../../reporting/store/report-params.model';
import { IUserInfo } from '../../user-info';
import * as fromAuth from '../../auth/store/auth.reducer';
import * as fromUser from '../../user-info';
@Component({
    selector: 'ef-contract-cumulative-feature',
    templateUrl: './contract-cumulative-feature.component.html',
    styleUrls: ['./contract-cumulative-feature.component.scss'],
    standalone: false
})
export class ContractCumulativeFeatureComponent implements OnInit, OnDestroy {
    process$: Observable<fromShared.Process>;
    @ViewChild(ContractCumulativePresenterComponent, { static: true })
    presenter: ContractCumulativePresenterComponent;

    public contractcums$: Observable<ContractCumulative[]>;
    public contracts$: Observable<Contract[]>;
    public serviceitems$: Observable<IServiceItem[]>;
    public directreports$: Observable<IDirectReport[]>;
    public txntypes$: Observable<CalcType[]>;
    public tasks$: Observable<ITask[]>;
    public userGroups$: Observable<IUserGroup[]>;
    public sessionDates$: Observable<SessionDates[]>;
    public reports$: Observable<Array<fromReports.Report>>;
    private auth$: Observable<fromAuth.State>;
    public userInfo$: Observable<IUserInfo>;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    active = true;
    IsLoading: boolean;
    commitText = "Cumulative commit in progress...";
    contractDataService: EntityCollectionService<fromDataServices.Contract.Contract>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    private RunReportsSubject = new ReplaySubject<{
        reports: Array<fromReports.Report>;
        queryparams: any;
        params: ReportParams;
    }>(1);
    cumulativeUploadDataService: EntityCollectionService<fromDataServices.CumulativeUpload.CumulativeUpload>;
    constructor(
        public entityServices: EntityServices,
        private log: LoggingService,
        private store: Store<fromReducer.State>,
        protected cdRef: ChangeDetectorRef
    ) {
        this.contractDataService =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Contract>(
                fromDataServices.Contract.entityName
            );

        this.cumulativeUploadDataService =
            entityServices.getEntityCollectionService<fromDataServices.CumulativeUpload.CumulativeUpload>(
                fromDataServices.CumulativeUpload.entityName
            );
    }

    ngOnInit() {
        this.store.dispatch(fromActions.getSessionDates());
        // this.store.dispatch(
        //     fromActions.postContractCumulatives({
        //         DirectOrIndirect: 'Direct',
        //         Todayonly: false,
        //         Asofdate: null,
        //         Tasks: null,
        //         ServiceItems: null,
        //         DirectReports: null,
        //         Txntype: null,
        //         CostCenters: null
        //     })
        // );
        this.contractDataService.getAll();
        this.store.dispatch(new fromLookups.LoadUserGroups());
        this.store.dispatch(new fromLookups.LoadTasks());
        this.store.dispatch(fromActions.getTxnTypes());
        this.store.dispatch(
            fromActions.getUsers({
                UserFilterID: 5,
                ShowInactive: true
            })
        );
        this.store.dispatch(new LoadServiceItems(false));
        this.setupObservables();
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        if (this.presenter.refreshTimer) {
            clearInterval(this.presenter.refreshTimer);
        }
        this.active = false;
        this.store.dispatch(fromActions.clearContractCumulatives());
    }

    setupObservables() {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.auth$ = this.store.pipe(select(fromAuth.getAuth));
        this.reports$ = this.store.pipe(
            select(fromReports.selectAll),
            map(x => clone(x))
        );

        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.sessionDates$ = this.store.pipe(
            select(fromReducer.selectSessionDates),
            map(x => clone(x))
        );

        this.contractcums$ = this.store.pipe(
            select(fromReducer.selectAll),
            map(c => clone(c))
        );

        this.contractcums$
            .pipe(takeWhile(() => this.active))
            .subscribe((cc) => {
                if (cc.some(x => x.Cumstatus == 'Building CTD') == true) {
                    this.IsLoading = true;
                } else {
                    this.IsLoading = false;
                }

            });

        this.userGroups$ = this.store.pipe(
            select(fromLookups.getUserGroupsLookup)
        );

        this.directreports$ = this.store.pipe(
            select(fromLookups.getDirectReportsLookup),
            map(x => clone(x)),
            // map(users => users.filter(x => x.IsActive == true)),
            map(x =>
                x.sort((a, b) => a.EmployeeName.localeCompare(b.EmployeeName))
            )
        );

        this.txntypes$ = this.store.pipe(
            select(fromReducer.selectTxnTypes),
            map(x => clone(x)),
            map(x => x.sort((a, b) => a.CalcDesc.localeCompare(b.CalcDesc)))
        );

        this.contracts$ = this.contractDataService.entities$.pipe(
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ContractDesc.localeCompare(b.ContractDesc))
            )
        );

        // this.directreports$ = this.store.pipe(
        //     select(fromLookups.getDirectReportsLookup),
        //     map(c =>
        //         c.filter(z => z.IsValidUser == true).map(x => ({
        //             value: x.EmployeeListID,
        //             label: x.EmployeeName
        //         })).sort((a, b) => a.label.localeCompare(b.label))
        //     )
        // );

        this.serviceitems$ = this.store.pipe(
            select(fromLookups.getServiceItemsLookup),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ServiceItem.localeCompare(b.ServiceItem))
            )
        );

        this.tasks$ = this.store.pipe(
            select(fromLookups.getTasksLookup),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.TaskLongName.localeCompare(b.TaskLongName))
            )
        );

        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors),
            tap(selected =>
                this.log.verbose({
                    type: 'ContractCumulativeFeatureComponent:selectedError$',
                    selected
                })
            )
        );
        const errors$ = this.store.pipe(select(fromShared.Errors.getErrors));
        this.selectedErrorWithStatus$ = combineLatest([
            this.selectedError$,
            errors$,
            this.contractcums$.pipe(filter(x => !!x))
        ]).pipe(
            tap(([selected, errors]) =>
                this.log.verbose({
                    type: 'ContractCumulativeFeatureComponent:errors$',
                    errors,
                    selected
                })
            ),
            map(
                ([selected, errors]) =>
                    errors.filter(
                        e =>
                            e.MsgEntityID === selected.MsgEntityID &&
                            e.MsgProcessID === selected.MsgProcessID
                    )[0]
            ),
            tap(selected =>
                this.log.verbose({
                    type: 'ContractCumulativeFeatureComponent:errors$:filtered',
                    selected
                })
            )
        );
    }

    setupSubscriptions() {
        this.userInfo$.pipe(takeWhile(() => this.active)).subscribe(userInfo => {
            this.store.dispatch(new fromLookups.LoadDirectReports({user: userInfo, activeOnly: false }));
        });
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        this.RunReportsSubject.pipe(withLatestFrom(this.auth$, this.userInfo$))
            .pipe(takeWhile(x => this.active))
            .subscribe(([{ reports, queryparams, params }, auth, userInfo]) => {
                const report = reports.find(x => x.RptNbr == 908);

                this.store.dispatch(
                    fromReports.runReport({
                        report: {
                            report,
                            params: {
                                ...params,
                                EmployeeListID: userInfo.EmployeeListID,
                                RptID: report.RptID
                            },
                            queryparams: {
                                ...queryparams,
                                User: userInfo.EmployeeListID,
                                Cust: auth.CustomerID,
                                GroupId: -1
                            }
                        }
                    })
                );
            });
    }

    onLoadSessionDates($event) {
        this.store.dispatch(fromActions.getSessionDates());
    }

    onCommitCumulatives($event) {
        this.IsLoading = true;
        this.store.dispatch(
            fromActions.postContractCumulatives($event)
        );
    }

    onTimer($event) {
        if ($event.timer === true) {
            clearInterval(this.presenter.refreshTimer);
            this.presenter.refreshTimer = setInterval(() => {
                //this.IsLoading = true;
                this.cdRef.detectChanges();
                this.store.dispatch(
                    fromActions.postContractCumulatives({
                        DirectOrIndirect: 'Direct',
                        Todayonly: false,
                        Asofdate: $event.date,
                        Tasks: null,
                        ServiceItems: null,
                        DirectReports: null,
                        Txntype: null,
                        CostCenters: null
                    })
                );
            }, 5000);
        } else {
            clearInterval(this.presenter.refreshTimer);
        }
    }

    onLoadContractCums($event) {
        this.log.verbose({
            type: 'ContractCumulativeFeatureComponent:onLoadContractCums'
        });
        this.store.dispatch(fromActions.clearContractCumulatives());
        if ($event != null) {
            this.store.dispatch(
                fromActions.postContractCumulatives({
                    DirectOrIndirect: $event.DirectOrIndirect,
                    Todayonly: $event.Todayonly,
                    Asofdate: $event.Asofdate,
                    Tasks: $event.Tasks,
                    ServiceItems: $event.ServiceItems,
                    DirectReports: $event.DirectReports,
                    Txntype: $event.Txntype,
                    CostCenters: $event.CostCenters
                })
            );
        }
    }

    onLoadAllContractCums($event) {
        this.log.verbose({
            type: 'ContractCumulativeFeatureComponent:onLoadAllContractCums'
        });
        this.store.dispatch(fromActions.getContractCumulatives());
    }

    onSaveContractCums($event) {
        this.log.verbose({
            type: 'ContractCumulativeFeatureComponent:onSaveContractCums'
        });
        this.store.dispatch(
            fromActions.putContractCumulatives({ contractcums: [$event] })
        );
    }

    onDeleteContractCum($event) {
        this.store.dispatch(
            fromActions.removeContractCum({ ids: [$event.Txnid] })
        );
    }

    onLoadDirectOrIndirect($event) {
        if ($event != null) {
            this.store.dispatch(
                fromActions.postContractCumulatives({
                    DirectOrIndirect: $event.DirectOrIndirect,
                    Todayonly: $event.Todayonly,
                    Asofdate: $event.Asofdate,
                    Tasks: $event.Tasks,
                    ServiceItems: $event.ServiceItems,
                    DirectReports: $event.DirectReports,
                    Txntype: $event.Txntype,
                    CostCenters: $event.CostCenters
                })
            );
        }
    }

    onRunReports(data) {
        this.RunReportsSubject.next(data);
    }

    onUploadJSON($event) {
        this.store.dispatch(
            fromActions.uploadCumulatives({JsonString: $event})
        );
        //this.cumulativeUploadDataService.getWithQuery({JsonString: $event});
    }
}
